import { eventQBus } from "../types/EventQBus";
import type { DresonRuleResolvedEvent } from "./FilterTypes";
import { LoadFilter } from "./LoadFilter";
import { TsBct } from "./TsBct";
import { addFeaturesToPageImpressionTracking } from "../tracking/FeatureTracking";
import { Filter } from "../filter/Filter";
import { addSanErrorToPageImpression, FILTER_FEATURES } from "../filter/FilterTracking";
import { FilterSection } from "../filter/FilterSection";
import { events } from "../events";
import { isActive } from "../toggle/Toggle";

export function registerFilterReloading() {
  if (isActive("HEUREKA_2407_MIGRATE_TO_REPTILE_NEXUS")) {
    events.initDresonRuleResolvedBridge();
    events.onDresonRuleResolved((data) => {
      if (data && data.rule !== FilterSection.template()?.currentDresonRule) {
        events.filterSectionLoad({
          rule: data.rule,
          page: data.page,
          ssid: TsBct.sfid(),
          entryRule: data.entryRule,
        });
      }
    });
    events.onDresonRuleResolveAborted(() => {
      Filter.handleError();
      addSanErrorToPageImpression("filterlist_empty");
      addFeaturesToPageImpressionTracking(FILTER_FEATURES);
    });
  } else {
    eventQBus.on("ftfind.dresonRule.resolved", (data: DresonRuleResolvedEvent) => {
      if (data && data.rule !== FilterSection.template().currentDresonRule) {
        if (data.count === 0) {
          Filter.handleError();
          addSanErrorToPageImpression("filterlist_empty");
          addFeaturesToPageImpressionTracking(FILTER_FEATURES);
        } else {
          events.filterSectionLoadDeprecated(data.rule, data.page, TsBct.sfid());
        }
      }
    });
  }

  eventQBus.on("ftfind.dresonRule.resolveAborted", Filter.handleError);

  events.onFilterSectionLoad(LoadFilter.onLoadFilters);
  events.onFilterSectionInitialLoaded(LoadFilter.onInitialLoadedFilters);
}
